import { useMutation } from 'urql';
import { gql } from 'urql';

export const DELETE_CATEGORIES_MUTATION = gql`
  mutation ($categoryIds: [Int!]!) {
    deleteCategories(input: { categoryIds: $categoryIds }) {
      ticketsInCategories
      rowsAffected
      success
    }
  }
`;

export interface DeleteCategoriesVariables {
  categoryIds: number[];
}

export interface DeleteCategoriesResponse {
  deleteCategories: {
    ticketsInCategories: number;
    rowsAffected: number;
    success: boolean;
  };
}

export const useFetchDeleteCategories = () => {
  return useMutation<DeleteCategoriesResponse, DeleteCategoriesVariables>(DELETE_CATEGORIES_MUTATION);
};
